module.exports = __webpack_public_path__ + "static/img/video.5661f3b7.png";